import {
  CircularProgress as MuiCircularProgress,
  CircularProgressProps as MuiCircularProgressProps,
} from '@mui/material';

export const muiCircularProgressClassNames = {
  circle: '.MuiCircularProgress-circle',
};

export type CircularProgressProps = {
  className?: string;
} & MuiCircularProgressProps;

const CircularProgress = ({ className, ...props }: CircularProgressProps) => {
  return <MuiCircularProgress className={className} {...props} />;
};

export default CircularProgress;
